import { useState } from "react"
import FileUpload from "./FileUpload"
import DateFormat from 'dateformat';
import Modal from "../common/Modal";
import { CSVLink } from "react-csv";
import { TENANT, USER_MOBILE_INFO_LOG_TYPE } from "../../config/constant";
import { getTenantWiseBulkUsersUploadFormat } from "./helper";
import { useRef } from "react";


const UploadUsersModal = ({open, handleClose, getBulkUploadHistory = () => {}, bulkUploadHistory, file, setFile }) => {
    const csvLink = useRef();
    const [csvData] = useState(getTenantWiseBulkUsersUploadFormat(TENANT));

    const downloadFormat = () => csvLink.current.link.click();

    return (
         <Modal show={open} handleClose={handleClose} >
            <div style={{ "display": "flex" }}>
              <div>
                <div className="modal-header">
                  <h2>Bulk Users Upload</h2>
                </div>
                <div className="modal-body">
                  <FileUpload endpoint="/sfa/admin/uploadBulkUser" getBulkUploadHistory={() => getBulkUploadHistory({type: USER_MOBILE_INFO_LOG_TYPE.USERS} )} file={file} setFile={setFile}/>
                  <div class="download-txt">
                    Download input format <span onClick={() => downloadFormat()}>Click Here</span>
                  </div>
                  <CSVLink
                    data={csvData}
                    filename={`bulk_users_upload_format.csv`}
                    data-interception='off'
                    ref={csvLink}
                  >
                  </CSVLink>
                </div>
              </div>
              <div style={{ width: "500px" }}>
                <div className="modal-header">
                  <h2>Upload History</h2>
                </div>
                <div className="modal-body">
                  <div className='user-managemnt-detail-table data-table'>
                    <table style={{ width: "auto" }}>
                      <thead>
                        <tr>
                          <th>Date & Time</th>
                          <th>Uploaded By</th>
                          <th>Records</th>
                          <th>Action</th>
                        </tr>

                      </thead>
                      <tbody>
                        {bulkUploadHistory && bulkUploadHistory.length > 0 && bulkUploadHistory.map((element, index) => (
                          <tr key={index}>
                            <td>{DateFormat(element.created_date, 'dd mmm yy, hh:MM TT')}</td>
                            <td className='show_ellipsis'>{element.display_name}</td>
                            <td>
                              <ul className='bulk_records'>
                                <li>{(element.total_record - element.failed_record) + " -"}</li>
                                <li className='failed_records'>{element.failed_record}</li>
                                <li>{"- " + element.total_record}</li>
                              </ul>
                            </td>
                            <td>
                              {element.csv_url ?
                                <ul class="action-btn">
                                  <li>
                                    <a href={element.csv_url} rel="noreferrer" target="_blank">
                                      <i class="ic-save_alt"></i>
                                    </a>
                                  </li>
                                </ul> : ""}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
    )
}

export default UploadUsersModal;